<template>
<div class="recommended-config-edit">
  <el-form ref="editForm" label-width="80px" :model="editJson" :rules="rules">
    <el-form-item label="被建议人" prop="reWkNo" v-if="!isEdit">
      <selecter v-model="editJson.reWkNo" @selecterData="getSelecterReWkNameData" :jobNo="editJson.reWkNo" :name="editJson.reWkName"></selecter>
    </el-form-item>
    <el-form-item label="建议人" prop="wkNo" v-if="!isEdit">
      <selecter v-model="editJson.wkNo" @selecterData="getSelecterWkNameData" :jobNo="editJson.wkNo" :name="editJson.wkName"></selecter>
    </el-form-item>
    <el-form-item label="时间" prop="dataRange">
      <el-date-picker
        v-model="editJson.dataRange"
        type="monthrange"
        align="right"
        start-placeholder=""
        end-placeholder=""
        value-format="yyyy-MM-dd"
        clearable
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item label="备注" prop="remarks">
      <el-input type="textarea" v-model="editJson.remarks" :rows="4" maxlength="500"></el-input>
    </el-form-item>
    <el-form-item label-width="0" class="atb-no-margin">
        <div class="atb-text-right">
          <el-checkbox v-if="!isEdit" v-model="addAlwarysChecked" class="addAlways" style="margin-right: 10px;">持续新增</el-checkbox>
          <!-- 保存 -->
          <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
          <!-- 取消 -->
          <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
        </div>
  </el-form-item>
  </el-form>
</div>

</template>
<script>
import _ from 'lodash';
import XEUtils from 'xe-utils'
export default {
  components: {
    selecter: () => import('@/component/global/customerSelect'),
  },
  props: {
    // 编辑信息
    editData: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    //监听传入的信息，深拷贝新的数据，保证数据避免被污染
    editData: {
      handler: function(newValue){
        let editJson = JSON.parse(JSON.stringify(newValue || {}));
        editJson.dataRange = [];
        if(editJson.startYear && editJson.startMonth && editJson.endYear && editJson.endMonth){
          let startDate = this.formatDate(`${editJson.startYear}-${editJson.startMonth}-01`, 'yyyy-MM-dd');
          let endDate = this.formatDate(`${editJson.endYear}-${editJson.endMonth}-01`, 'yyyy-MM-dd');
          editJson.dataRange = [startDate, endDate];
        }
        this.editJson = editJson;
        this.cacheEditJson = JSON.parse(JSON.stringify(this.editJson));
      },
      immediate: true
    }
  },
  data() {
    return {
      id: 'id',
      rules: {
        reWkNo: [
          { required: true, message: '被建议人必填', trigger: 'change' }
        ],
        wkNo: [
          { required: true, message: '建议人必填', trigger: 'change' }
        ],
        dataRange: [
          { required: true, type: 'array', message: '时间必填', trigger: 'change' }
        ]
      },
      addApi: this.$api.recommendedConfig.add,
      editApi: this.$api.recommendedConfig.update,
      addMethod: 'post',
      editMethod: 'post',
      editJson: {},
      cacheEditJson: {},
      depData: [],
      seleterWkNameData: [],
      seleterReWkNameData: [],
      addAlwarysChecked: false,
      loading: false,
      isSave: false,
      isEdit: false,
    }
  },
  mounted() {
    if( this.editJson[this.id] ) {
      this.isEdit = true;
    }
  },
  methods: {
    //取消操作
    cancel() {
      if(JSON.stringify(this.editJson) != JSON.stringify(this.cacheEditJson) && !this.isSave){
        this.$confirm('当前信息有数据变动，你是否确定要关闭 ?','提示',{
          confirmButtonText: '继续编辑',
          cancelButtonText: '确认关闭',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
          type: 'warning'
        }).then(()=>{}).catch(()=>{
          //取消编辑弹窗
          this.$parent.$parent.hide();
        })
      }else{
        //取消编辑弹窗
        this.$parent.$parent.hide();
      }
    },
    //提交操作
    submit() {
      //验证表单校验是否通过
      this.$refs['editForm'].validate(valid=>{
        //通过后提交数据
        if(valid){
          //判断是新增还是编辑操作
          var api = this.addApi;
          var apiMethod = this.addMethod;
          if(this.editJson[this.id]) {
            api = this.editApi;
            apiMethod = this.editMethod;
          }
          var params = this.resetSubmitParams(this.editJson);
          if(api)
            this.loading = true;
            //提交数据
            this.$ajax[apiMethod](api,params).then(response=>{
              if(response.code == this.$config.ResultCode.SUCCESS_CODE || !response.error){
                this.loading = false;

                //成功提示
                this.$message({
                  type: 'success',
                  message: this.successMsg || response.msg || this.$t('common.SubmitSuccess')
                });
                //标记是否已保存
                this.isSave = true;
                this.$emit('submitSuccess');
                if (this.addAlwarysChecked){
                  this.editJson = {};
                  this.$nextTick(() => {
                    this.$refs['editForm'].clearValidate();
                  });
                  return 0;
                }
                //取消弹窗
                this.cancel();
              }
            }).catch(()=>{ this.loading = false });
        }
      })
    },
    resetSubmitParams(params){
      const sendParams={};
      sendParams.id = params.id;
      if (this.isEdit) {
        sendParams.wkName = params.wkName;
        sendParams.reWkName = params.reWkName;
      } else {
        sendParams.wkName = params.wkNo? this.seleterWkNameData.find(t => t.jobNo == params.wkNo).name: '';
        sendParams.reWkName = params.reWkNo ? this.seleterReWkNameData.find(t => t.jobNo == params.reWkNo).name: '';
      }
      sendParams.wkNo = params.wkNo;
      sendParams.reWkNo = params.reWkNo;
      sendParams.remarks = params.remarks;
      sendParams.startTime = params.dataRange[0];
      sendParams.endTime = params.dataRange[1];
      return sendParams;
    },
    getSelecterWkNameData(data) {
      this.seleterWkNameData = data;
    },
    getSelecterReWkNameData(data) {
      this.seleterReWkNameData = data;
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
  }
}
</script>
<style scoped lang='scss'>
.recommended-config-edit {
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 100%;
  }
}
</style>